import { API_URL } from '../../../app-config/constants';
import type {
    ChatHistoryItem,
    ContextReference,
    CopilotPromptType,
    MiniCoach,
} from '../../react/features/AiCopilot/types';
import { get, post } from '../request';

const BASE_URL = `${API_URL}/copilot`;

copilotPrompt.operation = 'COMMAND';
export function copilotPrompt(
    type: CopilotPromptType,
    input: string,
    assistantId: string,
    id?: string,
    contextReference?: ContextReference
) {
    return post<ChatHistoryItem>(BASE_URL, { postData: { id, type, input, assistantId, contextReference } });
}

getAssistants.operation = 'READ';
export function getAssistants() {
    return get<MiniCoach[]>(`${BASE_URL}/assistants`);
}
